<div
  class="h-full flex flex-col md:grid md:grid-cols-3 bg-gray-50 dark:bg-gray-900 overflow-hidden"
>
  <div
    class="md:col-span-1 bg-gray-900 text-white flex flex-col overflow-hidden"
    [class.block]="selectedContact() === null && !isMobile"
    [class.hidden]="selectedContact() !== null && isMobile"
  >
    <div
      class="p-4 bg-gray-800 border-b flex justify-between items-center sticky top-0 z-10"
    >
      <h3 class="text-lg font-semibold">Conversas</h3>
    </div>

    <ul class="divide-y divide-gray-700 flex-1 overflow-y-auto">
      @for (contact of contacts(); track $index) {
      <li
        (click)="selectConversation(contact)"
        class="flex items-center p-4 cursor-pointer hover:bg-gray-800"
        [class.bg-gray-600]="contact.id==selectedContact()?.id"
      >
        <img
          [src]="
            contact.avatar ? contact.avatar.path : '/images/user_image.png'
          "
          class="w-12 h-12 rounded-full mr-3"
        />
        <div class="flex-1">
          <p class="text-sm font-medium">{{ contact.name }}</p>
          @if(contact.lastMessage){
          <p class="text-xs opacity-70">
            {{ contact.lastMessage }}
          </p>
          }
        </div>
        @if(contact.id != selectedContact()?.id){
        <span class="bg-red-500 text-white text-xs px-2 py-1 rounded-full">
          {{ contact.unreadCount }} </span
        >}
      </li>
      }
    </ul>
  </div>

  <div
    class="md:col-span-2 flex flex-col bg-white dark:bg-gray-900 overflow-y-auto"
    [class.block]="selectedContact() !== null && !isMobile"
    [class.hidden]="selectedContact() === null && isMobile"
  >
    @let contact = selectedContact();
    @if(contact){
    <ui-chat [contact]="contact" [newContact]="newContact()" [newMessage]="newMessage"></ui-chat>
    } @else{
    <div class="flex flex-col items-center text-center px-6">
      <img
        src="https://cdn.pixabay.com/photo/2021/08/24/03/42/romantic-chat-6569370_1280.png"
        alt="Logo"
        class="w-20 h-20 mb-4"
      />
      <h2 class="text-2xl font-semibold text-gray-700 dark:text-gray-200">
        Bem-vindo ao Chat
      </h2>
      <p class="text-gray-500 dark:text-gray-400 mt-2">
        Selecione um contato para começar a conversar.
      </p>
    </div>
    }
  </div>
</div>
